"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className="relative min-h-screen w-full overflow-hidden bg-background flex items-center justify-center" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(0.5rem)",
    transition: "opacity 200ms ease-out, transform 200ms ease-out"
  }}>
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/corporate_silhouettes_merging.png)",
      transform: isVisible ? "translateY(-2rem)" : "translateY(0)",
      transition: "transform 3s ease-out"
    }} />

      {}
      <div className="absolute inset-0 bg-background/70" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="glass-effect p-12 md:p-16 border-2 border-primary/30" style={{
        boxShadow: "0 0 32px hsla(220, 80%, 50%, 0.25), 0 8px 32px rgba(0, 0, 0, 0.3)"
      }}>
          {}
          <h1 className="text-foreground mb-4 drop-shadow-[0_0_8px_hsla(220,80%,50%,0.6)] !text-4xl">
            Fusions et Acquisitions & Création de Valeur
          </h1>

          {}
          <p className="text-muted-foreground text-xl md:text-2xl leading-relaxed mb-10 drop-shadow-[0_0_6px_hsla(220,80%,50%,0.5)]">Management Buyouts, Leveraged Buyouts, LOI, Due diligence IT, intégration post-fusion, carve-outs, accélération de valeur...&nbsp;</p>

          {}
          <div className="inline-block">
            <div className="glass-effect p-1.5 rounded-lg" style={{
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)"
          }}>
              <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-[0_8px_24px_hsla(220,80%,50%,0.35)] transition-all duration-[120ms] ease-in-out hover:scale-[1.03] active:scale-100 px-8 py-6 text-base font-semibold">
                <Link to="#contact">Parlons M&amp;A<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right size-5" aria-hidden="true" data-ast-id="f:/src/pages/MergersAcquisitionsValueCreation/sections/ServiceHero.tsx|sig:sll6rd" data-ast-start="2339" data-ast-end="3061"><path d="M5 12h14" data-ast-id="f:/src/pages/MergersAcquisitionsValueCreation/sections/ServiceHero.tsx|sig:8x4g74" data-ast-start="2722" data-ast-end="2886"></path><path d="m12 5 7 7-7 7" data-ast-id="f:/src/pages/MergersAcquisitionsValueCreation/sections/ServiceHero.tsx|sig:8xs5og" data-ast-start="2886" data-ast-end="3055"></path></svg></Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}